import { useState, useRef, useCallback } from "react";

const useMediaRecorder = (onRecordingStop) => {
  const [isRecording, setIsRecording] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null); // For playback
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const startRecording = useCallback(async () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        mediaRecorderRef.current = new MediaRecorder(stream, {
          mimeType: "audio/webm",
        }); // or 'audio/ogg; codecs=opus' etc.

        audioChunksRef.current = []; // Reset chunks

        mediaRecorderRef.current.ondataavailable = (event) => {
          audioChunksRef.current.push(event.data);
        };

        mediaRecorderRef.current.onstop = () => {
          const blob = new Blob(audioChunksRef.current, {
            type: mediaRecorderRef.current.mimeType,
          });
          setAudioBlob(blob);
          const url = URL.createObjectURL(blob);
          setAudioUrl(url);
          if (onRecordingStop) {
            onRecordingStop(blob, url);
          }
          // Stop microphone tracks
          stream.getTracks().forEach((track) => track.stop());
        };

        mediaRecorderRef.current.start();
        setIsRecording(true);
        setAudioBlob(null); // Clear previous blob
        setAudioUrl(null); // Clear previous URL
      } catch (err) {
        console.error("Error accessing microphone:", err);
        alert(
          "Could not access microphone. Please ensure permission is granted and try again."
        );
        // You might want to set an error state here
      }
    } else {
      alert("MediaDevices API not supported in this browser.");
    }
  }, [onRecordingStop]);

  const stopRecording = useCallback(() => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state === "recording"
    ) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
    }
  }, []);

  return { isRecording, startRecording, stopRecording, audioBlob, audioUrl };
};

export default useMediaRecorder;
